const config = {
    dev: {
        originId: 'gh_6e545a97baf3',
        BID: '110789',
        stockService: 'https://test-gateway.jinyi999.cn/rjhy-stock-diagnosis/api/',
        rjhyEdu: 'https://test-gateway.jinyi999.cn/rjhy-edu/api/',
        rjhyUser: 'https://test-gateway.jinyi999.cn/rjhy-user/api/',
        rjhyQr: 'https://gateway.chongnengjihua.com/rjhy-wechat-platform',
        rjhySms: 'https://test-gateway.jinyi999.cn/rjhy-sms/api/',
        rjhyFile: 'https://test-gateway.jinyi999.cn/rjhy-file/api/1/',
        rjhyNews: 'https://test-gateway.jinyi999.cn/rjhy-news/api/1/',
        rjhyGmgQuote: 'https://test-gateway.jinyi999.cn/rjhy-gmg-quote/api/1/',
        rjhyOptional: 'https://test-gateway.jinyi999.cn/rjhy-optional/api/1/',
        rjhyMiniLive: 'https://test-gateway.jinyi999.cn/rjhy-minilive/api/v1/',
        rjhyActivityManage: 'https://test-gateway.jinyi999.cn/rjhy-activity-manage/api/v1/',
        rjhyMarketSort: 'https://test-hq.caixun99.com/curhq/',
        rjhyDynamic: 'https://test-gateway.jinyi999.cn/rjhy-dynamic/api/1/',
        baseWebSocket: 'wss://qas.sylapp.cn/quote',
        authConf: {
            OrgCode: 'rh',
            Token: 'e9252a64-6ac8-4bf8-9725-6f106f682908',
            AppName: 'htzpc',
            AppVer: 'v1.0.0',
            AppType: 'pc',
            Tag: 'af91c60a-1acc-4150-9014-d11086cb9489',
        },
    },
    test: {
        originId: 'gh_6e545a97baf3',
        BID: '110789',
        stockService: 'https://test-gateway.jinyi999.cn/rjhy-stock-diagnosis/api/',
        rjhyEdu: 'https://test-gateway.jinyi999.cn/rjhy-edu/api/',
        rjhyUser: 'https://test-gateway.jinyi999.cn/rjhy-user/api/',
        rjhyQr: 'https://gateway.chongnengjihua.com/rjhy-wechat-platform',
        rjhySms: 'https://test-gateway.jinyi999.cn/rjhy-sms/api/',
        rjhyFile: 'https://test-gateway.jinyi999.cn/rjhy-file/api/1/',
        rjhyNews: 'https://test-gateway.jinyi999.cn/rjhy-news/api/1/',
        rjhyGmgQuote: 'https://test-gateway.jinyi999.cn/rjhy-gmg-quote/api/1/',
        rjhyOptional: 'https://test-gateway.jinyi999.cn/rjhy-optional/api/1/',
        rjhyMiniLive: 'https://test-gateway.jinyi999.cn/rjhy-minilive/api/v1/',
        rjhyActivityManage: 'https://test-gateway.jinyi999.cn/rjhy-activity-manage/api/v1/',
        rjhyMarketSort: 'https://test-hq.caixun99.com/curhq/',
        rjhyDynamic: 'https://test-gateway.jinyi999.cn/rjhy-dynamic/api/1/',
        baseWebSocket: 'wss://qas.sylapp.cn/quote',
        authConf: {
            OrgCode: 'rh',
            Token: 'e9252a64-6ac8-4bf8-9725-6f106f682908',
            AppName: 'htzpc',
            AppVer: 'v1.0.0',
            AppType: 'pc',
            Tag: 'af91c60a-1acc-4150-9014-d11086cb9489',
        },
    },
    production: {
        BID: '111361',
        originId: 'gh_a4dfed35c02a',
        stockService: 'https://hq.chongnengjihua.com/rjhy-stock-diagnosis/api/',
        rjhyEdu: 'https://gateway.chongnengjihua.com/rjhy-edu/api/',
        rjhyUser: 'https://gateway.chongnengjihua.com/rjhy-user/api/',
        rjhyQr: 'https://gateway.chongnengjihua.com/rjhy-wechat-platform',
        rjhySms: 'https://gateway.chongnengjihua.com/rjhy-sms/api/',
        rjhyFile: 'https://gateway.chongnengjihua.com/rjhy-file/api/1/',
        rjhyNews: 'https://gateway.chongnengjihua.com/rjhy-news/api/1/',
        rjhyGmgQuote: 'https://hq.chongnengjihua.com/rjhy-gmg-quote/api/1/',
        rjhyOptional: 'https://gateway.chongnengjihua.com/rjhy-optional/api/1/',
        rjhyMarketSort: 'https://stockhq-aliyun.caixun99.com/curhq/',
        rjhyMiniLive: 'https://gateway.chongnengjihua.com/rjhy-minilive/api/v1/',
        rjhyActivityManage: 'https://gateway.chongnengjihua.com/rjhy-activity-manage/api/v1/',
        rjhyDynamic: 'https://gateway.chongnengjihua.com/rjhy-dynamic/api/1/',
        baseWebSocket: 'wss://qas.sylapp.cn/quote',
        authConf: {
            OrgCode: 'rh',
            Token: 'e9252a64-6ac8-4bf8-9725-6f106f682908',
            AppName: 'htzpc',
            AppVer: 'v1.0.0',
            AppType: 'pc',
            Tag: 'af91c60a-1acc-4150-9014-d11086cb9489',
        },
    },
};

module.exports = config[process.env.NODE_ENV];
